/**
 * Скрипты подвала
 */
export default class Footer {
    private readonly $holder: JQuery;
    private readonly $scrollTopBtn: JQuery;

    private selectors = {
        scrollTopBtn: '.js-scroll-btn-footer-top',
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$scrollTopBtn = this.$holder.find(this.selectors.scrollTopBtn);
        this.init();
    }

    private init(): void
    {
        this.$scrollTopBtn.on('click', this.scrollTopHandler);
    }

    /**
     *  Функция скролла наверх
     * @private
     */
    private scrollTopHandler(): void {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
